import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface CommodityCodeOption {
  key: string;
  value: string;
}

export const getCommodityCodesAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetCommodityCode`,
  });
};

export type CommodityCodesResponse = CommodityCodeOption[];

export const fetchCommodityCodes = async (): Promise<CommodityCodesResponse> => {
  const response: AxiosResponse<CommodityCodesResponse> = await getCommodityCodesAPI();
  return response.data;
};
